import { Outlet } from "react-router-dom"
import Header from "./Header"
import Footer from "./Footer"
import { Suspense, useEffect } from "react"
import ProtectedRoute from "../Routes/ProtectedRoute"
import HeaderTemp from "./HeaderTemp"
import AutoLogout from "../Pages/LoginPage/AutoLogout"


export default function AppLayout() {
    const handleLogout = () => {
        localStorage.removeItem("token_erp");
        localStorage.removeItem("user_id_erp");
        localStorage.removeItem("company_id_erp");
        window.location.href = '/';
      };
      useEffect(()=>{
        if(!localStorage.getItem("token_erp") || !localStorage.getItem("user_id_erp") || !localStorage.getItem("company_id_erp")){
            handleLogout();
          }
      },[]);
    return (
        <ProtectedRoute>
       
            {/* <Header /> */}
            <AutoLogout/>
            <HeaderTemp/>
            <main>
                <Suspense fallback={<div>Loading...</div>}>
                    
                    <Outlet />
                    
                </Suspense>
            </main>
            <Footer />
        </ProtectedRoute>
    )
}